const angular = require('angular');

class NotificationMessageController {
    constructor($timeout, analyticsService, $sce, $scope) {
        this.$scope = $scope;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.$scope.$sce = this.$sce;
        const visibility = this.isVisible !== undefined ? this.isVisible : true;
        this.isVisible = false;
        this.containerClasses = this.containerClasses !== undefined ? this.containerClasses : '';
        this.isDismissible = this.isDismissible !== undefined ? this.isDismissible : true;
        this.linkTitle = this.linkTitle !== undefined ? this.linkTitle : this.link;
        this.$timeout(() => {
            this.isVisible = visibility;
        }, 1);
    }

    dismissClicked() {
        this.isVisible = false;
        if (angular.isFunction(this.onDismiss)) {
            this.$timeout(() => this.onDismiss());
        }
    }

    messageClicked(event) {
        if (angular.isFunction(this.onMessageClicked)) {
            this.onMessageClicked({ event });
        }
    }
}

NotificationMessageController.$inject = ['$timeout', 'AnalyticsService', '$sce', '$scope'];

const notificationMessageComponentDefinition = {
    controller: NotificationMessageController,
    bindings: {
        type: '@', // Type of notification (string. error/info)
        isVisible: '=?', // Get or set the current visibility of the notification - will trigger animations. (bool)
        title: '@?', // Optional title for the notification. (string)
        message: '@', // Message to the user regarding the notification (string - trusted HTML).
        isDismissible: '<?', // Show the close button to dismiss the notification, defaults to true. (bool)
        onDismiss: '&?', // Triggered if the user dismisses the notification. (Func)
        containerClasses: '@?',
        onMessageClicked: '&?', // click event when message body clicked
    },
    template: require('./notification-message.component.html').trim(),
};

module.exports = {
    NotificationMessageController,
    notificationMessageComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/notificationmessage/notification-message.component.js